import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search\">\n    <path d=\"m13.429 13.634-.88-.91.042-.039a5.313 5.313 0 1 0-.655.518v1.446a6.562 6.562 0 1 1 2.32-1.956l3.322 3.323v1.768l-4.15-4.15z\" fill=\"#000018\" fill-rule=\"nonzero\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol